import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var googleTranslate = require("google-translate")("AIzaSyBcd04enatkHi0ModNWlt0hSzMOgv_dzTk");

var translate = function translate(string, source, target) {
  return new Promise(function (resolve, reject) {
    googleTranslate.translate(string, source, target, function (err, translation) {
      // console.log("translation", translation);
      if (err) {
        console.log("err", err);
        reject(err);
      } else {
        resolve(translation.translatedText);
      }
    });
  });
};

var translateArrayLanguages = function translateArrayLanguages(string, source, targets) {
  return targets.map(function (target) {
    return new Promise(function (resolve, reject) {
      googleTranslate.translate(string, source, target, function (err, translation) {
        // console.log("translation", translation);
        if (err) {
          console.log("err", err);
          reject(err);
        } else {
          resolve(_defineProperty({}, target, translation.translatedText));
        }
      });
    });
  });
};

export { translate, translateArrayLanguages };